<template>
  <div
    :class="{
      'background-post-tint color-post-background border-post-tint': !wallColors,
      'background-wall-tint color-wall-background border-wall-tint': wallColors,
      'align-right': alignRight
    }"
    class="premium-ribbon-overlay"
  >
    <inline-svg
      v-if="relatedSubscriptionPlan?.icon_url"
      class="inline-svg-icon mx-1"
      :height="20"
      :width="20"
      :src="relatedSubscriptionPlan.icon_url.original"
      :title="`${relatedSubscriptionPlan.title} plan icon`"
    />
    <i-custom-padlock v-else />
  </div>
</template>

<script>
export default {
  props: {
    relatedSubscriptionPlan: {
      type: Object,
      default: null
    },
    wallColors: {
      type: Boolean,
      default: false
    },
    alignRight: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
// Needed to do in css to override .v-avatar svg rule which inline setting doesn't do
.app-icon {
  height: 20px;
  width: 18px;
}

.premium-ribbon-overlay {
  position: absolute;
  width: 37px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  top: -1px;
  z-index: var(--z-index-base);

  &.align-right {
    right: 16px;
  }

  &::after {
    position: absolute;
    content: "";
    top: 100%;
    transform: translateY(-50%);
    border-top: 7px solid transparent;
    border-right: 37px solid var(--wall-tint);
    border-bottom: 7px solid transparent;
  }

  &.background-post-tint {
    &::after {
      border-right: 37px solid var(--post-tint);
    }
  }
}
</style>
